// extracted by mini-css-extract-plugin
export var wrapper = "newPostList-module--wrapper--3liGo";
export var labelIcon = "newPostList-module--labelIcon--mJbl3";
export var list = "newPostList-module--list--fNix9";
export var item = "newPostList-module--item--3S9x3";
export var article = "newPostList-module--article--331zU";
export var eyeCatch = "newPostList-module--eyeCatch--2sil9";
export var title = "newPostList-module--title--CvUEI";